<div class="userInitialsHolder">
	@for (user of firstUsers; track user) {
		<div class="userInitials" [class.big]="big" [matTooltip]="user?.fullname">
			@if (user?.firstname && user?.lastname) {
				{{ user?.firstname?.charAt(0) }}{{ user?.lastname?.charAt(0) }}
			}
			@if (!(user?.firstname && user?.lastname)) {
				{{ user?.username?.charAt(0) }}
			}
		</div>
	}
	@if (hasAdditionalUsers) {
		<div class="userInitials" [class.big]="big" [matTooltip]="remainingUsersTooltip" matTooltipClass="newline">...</div>
	}
</div>
